import { generateTheme, IThemeConfig } from './theme';
import merge from 'lodash.merge';
import { getEoraThemeColours, getBrandColours, getBaseColours } from '../fundamentals/colours/eoraColourUtils';
import { THEMES } from '@cmctechnology/webinvest-constants';
import { themeSetUp } from './themeUtils';
import { BaseColours, baseColours } from '../fundamentals/colours/baseColours';
import { BrandColours, MainBrandColours } from '../fundamentals/colours/colourInterfaces';

const getEoraColours = (darkMode: boolean) => {
  const eoraColours = getEoraThemeColours(THEMES.CMC, darkMode);
  const eoraBaseColours = getBaseColours(eoraColours.eoraCoreColours, darkMode);

  return {
    eoraColours,
    baseColours: merge(baseColours, eoraBaseColours) as BaseColours,
    brandColours: getBrandColours(eoraColours.eoraBrandColours) as BrandColours | MainBrandColours
  };
};

const cmcThemeConfigBase: Omit<IThemeConfig, 'eoraColours' | 'brandColours' | 'baseColours'> = {
  name: 'cmc',
  logos: {
    header: {
      color: `/l/cmc/primary.svg`,
      white: `/l/cmc/white.svg`
    },
    mark: {
      color: `/l/cmc/32x32-color.svg`,
      black: `/l/cmc/32x32-black.svg`,
      white: `/l/cmc/32x32-white.svg`
    },
    footer: {
      color: `/l/cmc/primary.svg`,
      white: `/l/cmc/white.svg`
    },
    whiteLabel: {
      color: `/l/cmc/color.svg`,
      black: `/l/cmc/black.svg`,
      white: `/l/cmc/white.svg`
    },
    cmcMarketsLogo: {
      color: `/l/cmc-specific/cmcmarkets/primary.svg`,
      accent: `/l/cmc-specific/cmcmarkets/accent.svg`,
      white: `/l/cmc-specific/cmcmarkets/white.svg`,
      textLight: `/l/cmc-specific/cmcmarkets/text-light.svg`,
      black: `/l/cmc-specific/cmcmarkets/black.svg`
    },
    cmcInvestLogo: {
      color: `/l/cmc-specific/cmcinvest/primary.svg`,
      accent: `/l/cmc-specific/cmcinvest/accent.svg`,
      white: `/l/cmc-specific/cmcinvest/white.svg`,
      textLight: `/l/cmc-specific/cmcinvest/text-light.svg`,
      black: `/l/cmc-specific/cmcinvest/black.svg`
    },
    cmcInvestWhiteLogo: {
      color: `/l/cmc-specific/cmcinvestwhite/primary.svg`,
      black: `/l/cmc-specific/cmcinvestwhite/black.svg`,
      textLight: `/l/cmc-specific/cmcinvestwhite/text-light.svg`
    }
  },
  publicSiteConfig: {
    backgroundImage: '/l/cmc/login/b.png'
  }
};

export const cmcThemeConfig: IThemeConfig = {
  ...cmcThemeConfigBase,
  ...getEoraColours(false)
};

export const cmcDarkThemeConfig: IThemeConfig = {
  ...cmcThemeConfigBase,
  ...getEoraColours(true)
};

export const cmcTheme = themeSetUp(THEMES.CMC, false, {}, {});
export const cmcDarkTheme = themeSetUp(THEMES.CMC, true, {}, {});

// Note: Do not remove next 4 functions
// Used to test different scenarios
// 1. Logo without custom branding
// 2. iconColours overrides
const demoThemeConfigOverrides = {
  logos: {
    header: ''
  }
};

const generateNoGlobalTheme = generateTheme(merge({}, cmcThemeConfig, demoThemeConfigOverrides));
const componentOverrides = {};

export const themeNoGlobalStyles = merge(
  {
    ...merge({}, generateNoGlobalTheme, componentOverrides),
    name: 'Demo overrides',
    hasGlobalStyles: false
  },
  {
    colours: {
      misc: {
        background: 'aliceblue' // Override bg colour
      }
    }
  }
);
